import Icon from '../components/Icon.vue'

Icon.register({"map-marker":{"width":1024,"height":1792,"paths":[{"d":"M768 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1024 640q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-marker.js
// module id = 703
// module chunks = 0